<template>
	<div>
		<div class="container hidden-xs">
			<b-breadcrumbs :items="breadcrumbs"/>
		</div>
		<section class="container">
			<div class="row">
				<div class="col-xs-12">
					<h1>New page</h1>
					<div class="page-summary-text">
						Add a new page
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<h2>Details</h2>
				</div>
				<div class="col-xs-12 col-sm-4">
					<label for="title">Title</label>
					<label
						v-if="$v.page.title.$error && !$v.page.title.required"
						class="label error pull-right"
					>Required</label>
					<input
						v-model="page.title"
						:class="{ 'error': $v.page.title.$error }"
						type="text"
						name="title"
						class="form-control"
						placeholder="Title"
					/>
				</div>
				<div class="col-xs-12 col-sm-8">
					<label for="summary">Summary</label>
					<label
						v-if="$v.page.meta_description.$error && !$v.page.meta_description.required"
						class="label error pull-right"
					>Required</label>
					<input
						v-model="page.meta_description"
						:class="{ 'error': $v.page.meta_description.$error }"
						type="text"
						name="summary"
						class="form-control"
						placeholder="Summary"
					/>
				</div>
				<div class="col-xs-12">
					<label
						v-if="$v.page.content.$error && !$v.page.content.required"
						class="label error pull-right"
					>Required</label>
					<template :class="{ 'error': $v.page.content.$error }">
						<jodit-vue v-model="page.content"/>
					</template>
				</div>
			</div>
			<hr>
			<div class="row">
				<div class="col-xs-12">
					<div class="container center">
						<router-link to="/admin/pages">
							<b-btn class="btn-md btn-default">Cancel</b-btn>
						</router-link>
						&nbsp;&nbsp;&nbsp;
						<b-btn class="btn-md btn-primary" @click="savePage">Save</b-btn>
					</div>
				</div>
			</div>
			<br>
			<br>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.form-control {
		margin-bottom: 15px;
		border-radius: 4px !important;
	}
	.btn-primary {
		height: 40.25px;
	}
	.error {
		border-color: red;
		color: red;
	}
</style>

<script>
import { required } from 'vuelidate/lib/validators';
import { Notification } from 'uiv';
import joditVue from 'jodit-vue';
import { mapGetters } from 'vuex';

export default {
	components: { joditVue },
	data() {
		return {
			page: {
				title: null,
				meta_description: null,
				content: '',
			}
		};
	},
	validations: {
		page: {
			title: { required },
			meta_description: { required },
			content: { required },
		}
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		},
	},
	methods: {
		async savePage() {
			if (this.$v.page.$invalid) {
				this.$v.page.$touch();
			} else {
				try {
					await this.$axios.post('/page', this.page);
					this.$router.push({ path: '/admin/pages' });
					Notification.notify({
						type: 'success',
						title: 'Page created successfully.',
						duration: 10000
					});
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create page.',
						content: e.response ? e.response.data.message : '',
						duration: 10000
					});
				}
			}
		}
	}
};
</script>
